<template>
    <div class="interface">
      <b-card class="edit-card">
        <div class="logo">
              <img class="logo-menu" src="@/assets/images/logo.png" @click="$router.push('/')" />
          </div>

        <b-button @click="$router.push('/')" class="title-btn">
          <i class="icon-btn material-icons">arrow_back</i>Voltar
        </b-button>
          <div>
                <h3 class="title">Editar Perfil</h3>
              <b-form class="form-row" @submit.prevent="editProfile">

                <div class="form-group col-md-6">
                  <label class="edit-label">Nome:</label>
                  <b-form-input
                      v-model="user.name"
                      type="text"
                      placeholder="Nome"
                  ></b-form-input>
                </div>

                <div class="form-group col-md-6">
                  <label class="edit-label">E-mail:</label>
                  <b-form-input
                      v-model="user.email"
                      type="email"
                      placeholder="E-mail"
                  ></b-form-input>
                </div>

                <div class="form-group col-md-6">
                  <label class="edit-label">Documento:</label>
                  <b-form-input
                      v-model="user.document"
                      type="text"
                      placeholder="Documento"
                  ></b-form-input>
                  </div>

                <div class="form-group col-md-6">
                  <label class="edit-label">Telefone:</label>
                  <b-form-input
                      v-model="user.telephone"
                      type="tel"
                      placeholder="Telefone"
                  ></b-form-input>
                </div>

                <div v-if="extra_field_id !== ''" class="form-group col-md-6">
                  <label class="edit-label">Fuso horário:</label>
                  <b-form-select
                      v-model="selected"
                      :options="timezone_options"
                      class="form-select"
                  ></b-form-select>
                  </div>

                <b-button class="password-button" v-b-modal.modal-multi-1>Alterar Senha</b-button>
                  <b-modal body-class="my-class" id="modal-multi-1" size="md" title="Alterar senha" centered no-stacking hide-header hide-footer>
                    <p class="my-2">Insira seus dados para receber a chave por e-mail:</p>
                    <label>CPF:</label>
                    <b-form-input
                      v-model="change_password.cpf"
                      type="text"
                      placeholder="CPF"></b-form-input><br>
                      <label>E-mail:</label>
                    <b-form-input
                      v-model="change_password.email"
                      type="text"
                      placeholder="E-mail"></b-form-input>
                    <b-button class="ok" @click="requestRecoverPasswordCode">Ok</b-button>
                  </b-modal>

                   <b-modal body-class="my-class" id="modal-multi-2" title="Alterar senha" size="md" centered no-stacking  hide-header hide-footer>
                    <p class="my-2">Insira a chave recebida no e-mail:</p>
                    <b-form-input
                      v-model="change_password.code"
                      type="text"
                      placeholder="Chave"></b-form-input>
                    <b-button class="ok" @click="sendRecoverPasswordCode">Ok</b-button>
                  </b-modal>

                  <b-modal body-class="my-class" id="modal-multi-3" title="Alterar senha" size="md" centered no-stacking hide-header hide-footer>
                    <p class="my-2">Nova senha:</p>
                    <b-form-input
                      v-model="change_password.new_password"
                      type="text"
                      placeholder="Nova senha"></b-form-input>
                    <p class="my-1">Repita a nova senha:</p>
                    <b-form-input
                      v-model="change_password.new_password_confirm"
                      type="text"
                      placeholder="Nova senha"></b-form-input>
                    <b-button class="ok" @click="resetPassword">Ok</b-button>
                  </b-modal>

                <b-button type="submit" class="title-btn save">
                  <i class="icon-btn material-icons"></i>Salvar
                </b-button>
              </b-form>
          </div>
      </b-card>
  </div>
</template>

<style lang="stylus" scoped>

    @import '../style/colors.styl';
    @import '../style/fonts.styl';
    @import '../style/spacing.styl';

    /deep/ .my-class
      border-radius radius-xl
      background white
      color black
      border-color #e0e0e0

    .ok
      background linear-gradient(135deg, primary 0%, #FF7A29 100%)
      border none
      color white
      margin-top space-md
      margin-left auto
      display block
      padding space-sm space-lg
      border-radius radius-md
      font-weight 600
      transition all transition-base

      &:hover
        background linear-gradient(135deg, #FF7A29 0%, #FF6810 100%)
        transform translateY(-2px)
        box-shadow shadow-orange-lg

    .title-btn
      background linear-gradient(135deg, primary 0%, #FF7A29 100%)
      border none
      color white
      font-weight 600
      padding space-sm space-lg
      border-radius radius-md
      transition all transition-base
      display flex
      align-items center
      gap space-sm
      box-shadow shadow-sm

      &:hover
        background linear-gradient(135deg, #FF7A29 0%, #FF6810 100%)
        transform translateY(-2px)
        box-shadow shadow-orange-lg
        color white

      .icon-btn
        font-size 1.2rem

    .modal-content
      background-color white
      border-radius radius-xl
      color black
      font-size 1rem
      font-weight 600
      line-height 1.5

    .modal-body
      border-radius radius-md
      margin space-sm
      background-color white

    .modal-header, .modal-footer
      border-color #e0e0e0

    .modal
      text-align center

    .password-button
      width fit-content
      margin-top space-lg
      background linear-gradient(135deg, primary 0%, #FF7A29 100%)
      border none
      color white
      font-weight 600
      padding space-sm space-lg
      border-radius radius-md
      transition all transition-base

      &:hover
        background linear-gradient(135deg, #FF7A29 0%, #FF6810 100%)
        transform translateY(-2px)
        box-shadow shadow-orange-lg

    .toggle-collapse
      margin-top space-lg
      width 20%

    .logo
      margin-bottom space-2xl
      text-align center

    .save
      align-content flex-end
      margin-top space-lg
      width fit-content
      margin-left auto

    .edit-label
      margin-top space-md
      font-weight 600
      color #2c3e50
      display block
      margin-bottom space-sm

    .form-control
      margin 0
      border 2px solid #e0e0e0
      border-radius radius-md
      padding space-sm space-md
      transition all transition-base
      height 48px

      &:focus
        border-color primary
        box-shadow 0 0 0 4px rgba(255, 140, 66, 0.1)
        outline none

    .interface
        min-height 100%
        min-height 100vh
        display flex
        align-items center
        background linear-gradient(135deg, #f8f9fa 0%, #e8e8e8 100%)
        padding space-xl 0

    .edit-card
        width 80%
        max-width 1000px
        min-height 81vh
        padding space-2xl
        margin 0 auto
        display block
        background linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)
        border-radius radius-2xl
        box-shadow shadow-xl
        animation fadeIn 0.5s ease-out

    @keyframes fadeIn
      from
        opacity 0
        transform translateY(20px)
      to
        opacity 1
        transform translateY(0)

    .logo-menu
        cursor pointer
        max-width 200px
        transition all transition-base

        &:hover
          transform scale(1.05)

    .card-body
        background-color transparent
        padding 0

    form
        width 100%

        *
            font-family Roboto-Regular

        .title
            text-align start
            font-size 2rem
            font-weight 700
            background linear-gradient(135deg, primary 0%, accent 100%)
            -webkit-background-clip text
            -webkit-text-fill-color transparent
            background-clip text
            margin-bottom space-xl

        input, button
            height 48px
            padding space-sm space-md

        input
            margin space-md 0
            border-radius radius-md

        button
            width 100%

    // Responsive
    @media (max-width: 768px)
      .edit-card
        width 95%
        padding space-xl space-lg

      .logo
        margin-bottom space-xl

      form .title
        font-size 1.75rem

</style>

<script>

import { request } from '@/services'
import { toast } from '@/utils'

export default {
  data: () => ({
    user: {
      name: '',
      email: '',
      document: '',
      telephone: ''
    },
    change_password: {
      cpf: '',
      email: '',
      code: '',
      new_password: '',
      new_password_confirm: ''
    },
    title: 'Perfil',
    info: null,
    selected: null,
    extra_field_id: '',
    timezone_options: [
      {
        value: null,
        text: 'Não selecionado'
      },
      {
        value: 'America/Noronha',
        text: 'Fernando de Noronha'
      },
      {
        value: 'America/Sao_Paulo',
        text: 'Brasília'
      },
      {
        value: 'America/Manaus',
        text: 'Amazonas'
      },
      {
        value: 'America/Rio_Branco',
        text: 'Acre'
      }
    ]
  }),
  mounted () {
    this.getUser()
  },
  props: ['userId'],
  methods: {
    async requestRecoverPasswordCode () {
      this.info = null
      this.info = {
        cpf: this.change_password.cpf,
        email: this.change_password.email
      }
      request.post('/recover/request', this.info, response => {
        this.$bvModal.hide('modal-multi-1')
        this.$bvModal.show('modal-multi-2')
      }, error => {
        this.$bvModal.hide('modal-multi-1')
        toast(this, 'danger', 'Erro ao enviar código.', error)
      })
    },
    async sendRecoverPasswordCode () {
      this.info = null
      this.info = {
        cpf: this.change_password.cpf,
        email: this.change_password.email,
        code: this.change_password.code
      }
      request.post('/recover/confirm', this.info, response => {
        this.$bvModal.hide('modal-multi-2')
        this.$bvModal.show('modal-multi-3')
      }, error => {
        this.$bvModal.hide('modal-multi-2')
        toast(this, 'danger', 'Erro.', error)
      })
    },
    async resetPassword () {
      this.info = null
      this.info = {
        password: this.change_password.new_password,
        password_confirmation: this.change_password.new_password_confirm
      }
      request.post('/reset_password', this.info, response => {
        this.$bvModal.hide('modal-multi-3')
        if (response.status === 200) {
          toast(
            this,
            'success',
            'Senha alterada.',
            'Senha atualizada com sucesso'
          )
        }
      }, error => {
        this.$bvModal.hide('modal-multi-3')
        toast(this, 'danger', 'Erro.', error)
      })
    },
    async getUser () {
      request.get('/user/show/' + this.userId, response => {
        this.user = response.data.user
        if (response.data.user.extra_fields !== undefined || response.data.user.extra_fields !== null) {
          this.selected = response.data.user.extra_fields[0].value.value
          this.extra_field_id = response.data.user.extra_fields[0].value.extra_field_id
        }
      }, error => {
        toast(this, 'danger', 'Erro ao carregar os dados.', error)
      })
    },
    async editProfile () {
      if (this.extra_field_id !== '') {
        this.$set(this.user, this.extra_field_id, this.selected.value)
      }
      request.post('/auth/update/' + this.userId, this.user, response => {
        this.$router.replace({ path: '/' })
        if (response.status === 200) {
          toast(
            this,
            'success',
            'Perfil editado com sucesso',
            'Perfil atualizado com sucesso'
          )
        }
      }, error => {
        toast(this, 'danger', 'Erro ao editar perfil.', error)
      })
    }
  }
}
</script>
